import {Redo2, Undo2} from "lucide-react";
import {Button} from "@/components/ui/button.tsx";
import {ButtonGroup} from "@/components/ui/button-group.tsx";
import {useDungeonEditorHistory} from "./DungeonEditorHistory.tsx";

export default function DungeonEditorHistoryControls() {
    const {canUndo, canRedo, undo, redo} = useDungeonEditorHistory();

    return <ButtonGroup>
        <Button type="button" variant="outline" size="icon-sm" title="Rückgängig (Strg+Z)"
                aria-label="Rückgängig" disabled={!canUndo} onClick={undo}>
            <Undo2/>
        </Button>
        <Button type="button" variant="outline" size="icon-sm" title="Wiederholen (Strg+Y)"
                aria-label="Wiederholen" disabled={!canRedo} onClick={redo}>
            <Redo2/>
        </Button>
    </ButtonGroup>;
}
